/**
 * 设备检测工具
 * @description 提供设备类型检测和浏览器信息获取功能
 */

interface deviceInter {
  match: (pattern: RegExp) => RegExpMatchArray | null;
}

interface BrowserInter {
  browser: string;
  version: string;
}

/**
 * 检测设备类型
 * @returns 手机返回true，否则返回false
 */
export const deviceDetection = (): boolean => {
  const sUserAgent: deviceInter = navigator.userAgent.toLowerCase() as any;
  // const bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
  const bIsIphoneOs = sUserAgent.match(/iphone os/i)?.[0] === 'iphone os';
  const bIsMidp = sUserAgent.match(/midp/i)?.[0] === 'midp';
  const bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i)?.[0] === 'rv:1.2.3.4';
  const bIsUc = sUserAgent.match(/ucweb/i)?.[0] === 'ucweb';
  const bIsAndroid = sUserAgent.match(/android/i)?.[0] === 'android';
  const bIsCE = sUserAgent.match(/windows ce/i)?.[0] === 'windows ce';
  const bIsWM = sUserAgent.match(/windows mobile/i)?.[0] === 'windows mobile';
  return bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM;
};

/**
 * 获取浏览器型号以及版本
 * @returns 浏览器信息对象
 */
export const getBrowserInfo = (): BrowserInter => {
  const ua = navigator.userAgent.toLowerCase();
  const re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
  const m = ua.match(re);
  const Sys: BrowserInter = {
    browser: m ? m[1].replace(/version/, "'safari") : 'unknown',
    version: m ? m[2] : 'unknown',
  };

  return Sys;
};
